module.exports = __webpack_public_path__ + "img/2.2.cb22d06b.png";